import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import { currentYear } from "../../../Common/FewCommonMethods";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import OnlyYearRange from "../../../Common/OnlyYearRange";

const generateDateOptions = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 1990;
  const optionsDate = [];

  for (let year = startYear; year <= currentYear; year++) {
    optionsDate.push({
      value: year.toString(),
      label: year.toString(),
    });
  }

  return optionsDate;
};

const validationSchema = Yup.object().shape({
  university: Yup.string().required("University is required"),
  field: Yup.string().required("Field of Study is required"),
  degree_id: Yup.string().required("Degree is required"),
  from_year: Yup.string().required("From year is required"),
  to_year: Yup.string()
    .required("To year is required")
    .test(
      "date-comparison",
      "To year must be greater than or equal to From year",
      function (value) {
        const { from_year } = this.parent;
        return parseInt(value) >= parseInt(from_year);
      }
    )
    .test(
      "year-gap",
      "Gap between From year and To year must not exceed 10 years",
      function (value) {
        const { from_year } = this.parent;
        if (!from_year || !value) return true;
        const gap = parseInt(value) - parseInt(from_year);
        return gap <= 10;
      }
    ),
});

export default function ProfileModelAcademicInfo({
  edittype,
  formData,
  setFormData,
  setModelAcademic,
}) {
  const [formData1, setFormData1] = useState("");
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [updateIndex, setUpdateIndex] = useState(null);
  const dispatch = useDispatch();
  const degreelistss = useSelector(
    ({ categary: { degreelist } }) => degreelist
  );

  useEffect(() => {
    if (formData?.education) {
      setFormData1(formData);
    }
  }, [formData, formData?.education]);

  const formik = useFormik({
    initialValues: {
      university: "",
      field: "",
      degree_id: "",
      from_year: "",
      to_year: "",
    },
    validationSchema,
    onSubmit: (values) => {
      if (updateIndex != null) {
        setFormData1((prevData) => ({
          ...prevData,
          education: prevData?.education?.map((edu, index) =>
            index === updateIndex ? values : edu
          ),
        }));
      } else {
        setFormData1((prevData) => ({
          ...prevData,
          education: [...(prevData?.education || []), values],
        }));
      }
      closeForm();
    },
  });

  const openForm = (index = null) => {
    if (index != null) {
      setUpdateIndex(index);
      const edu = formData1?.education[index];
      formik.setValues({
        id: edu.id,
        university: edu?.university,
        field: edu?.field,
        degree_id: edu?.degree_id,
        from_year: edu?.from_year,
        to_year: edu?.to_year,
      });
    } else {
      setUpdateIndex(null);
      formik.resetForm();
    }
    setIsFormVisible(true);
  };

  const closeForm = () => {
    setIsFormVisible(false);
    setUpdateIndex(null);
    formik.resetForm();
  };

  const handleSpecialityChange = (selectedOption) => {
    formik.setFieldValue("degree_id", selectedOption.value);
  };

  const handleStartDateChange = (selectedOption) => {
    formik.setFieldValue("from_year", selectedOption.value);
  };

  const handleEndDateChange = (selectedOption) => {
    formik.setFieldValue("to_year", selectedOption.value);
  };

  const deleteEducation = (index, item1) => {
    if (edittype == 1) {
      // Always mark as deleted (status: 3), even if last item
      setFormData1((prevData) => ({
        ...prevData,
        education: prevData?.education?.map((item, i) =>
          i == index ? { ...item, status: 3 } : item1?.id == item?.id ? { ...item, status: 3 } : item
        ),
      }));
    } else {
      // Remove new entries completely
      setFormData1((prevData) => ({
        ...prevData,
        education: prevData?.education?.filter((_, i) => i !== index),
      }));
    }
  };

  const SubmitandNext = () => {

    if (formData1?.education?.length > 0) {
      if (edittype == 1) {
        const allInactive = formData1.education.every((edu) => edu.status == 3);
        if (allInactive) {
          formik.setFieldError("education", "At least add one education");
          return;
        }

        setFormData((prevData) => ({
          ...prevData,
          education: [...formData1.education],
        }));
        const data = {
          type: "education",
          education: [...formData1.education],
        };
        dispatch(updateProfile(data));
        setModelAcademic(false);
      } else {
        setFormData((prevData) => ({
          ...prevData,
          education: [...formData1?.education],
        }));
        setModelAcademic(false);
      }
      closeForm();
    } else {
      formik.setFieldError("education", "At least add one education");
    }
  };


  useEffect(() => {
    if (formData1?.education?.length > 0) {
      formik.setFieldError("education", null);
    }
  }, [formData?.education]);

  useEffect(() => {
    if (updateIndex !== null) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [updateIndex]);

  return (
    <>
      <button
        onClick={() => setModelAcademic((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <div>
          <div className="">
            <h6 className="add-edu"> Add Education</h6>
            <div className="row education-row">
              {Array.isArray(formData1?.education) &&
                formData1.education
                  .filter((item) => !(edittype === 1 && item.status === 3))
                  .map((item, index) => (
                    <div className="col-md-4" key={index}>
                      <div className="add-education-wrapper">
                        <div className="add-first">
                          <div>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/bag.svg`}
                              alt=""
                            />
                          </div>
                          <div>
                            <h2>
                              {degreelistss?.map((county) => {
                                if (item.degree_id === county.id) {
                                  return <>{county.title}</>;
                                }
                              })}
                              - {item.university}
                            </h2>
                            <h5>{item.field}</h5>
                            {/* <p>
                              {item.from_year} -{" "}
                              {item.to_year === currentYear()
                                ? "Present"
                                : item.to_year}
                            </p> */}
                            <p>
                              <OnlyYearRange fromYear={item.from_year} toYear={item.to_year} />
                            </p>

                          </div>
                        </div>
                        <div className="add-button-education">
                          <button onClick={() => deleteEducation(index, item)}>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                              alt=""
                            />
                          </button>
                          <button onClick={() => openForm(index)}>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                              alt=""
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
            {formik.errors.education && (
              <p style={{ color: "red" }}>{formik.errors.education}</p>
            )}
            <button
              className="buttons border-button mt-3 mb-4"
              onClick={() => openForm()}
            >
              Add More Education
            </button>
          </div>

          {isFormVisible && (
            <div className="add-education-modal">
              <button
                onClick={() => setIsFormVisible((state) => !state)}
                className="btn close-button modal-profile-close"
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
                  alt=""
                />
              </button>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="add-edu">
                      {updateIndex != null ? "Edit" : "Add"} Education
                    </h3>
                    <div className="row">
                      <div className="form-group col-md-12">
                        <label className="label">School / University <AsteriskLabel /></label>
                        <input
                          type="text"
                          name="university"
                          className="form-control"
                          placeholder="Enter name"
                          value={formik.values.university}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.university &&
                          formik.errors.university && (
                            <div style={{ color: "red" }}>
                              {formik.errors.university}
                            </div>
                          )}
                      </div>
                      <div className="form-group col-md-12">
                        <label className="label">Degree <AsteriskLabel /></label>
                        <ReactSelect
                          options={
                            Array.isArray(degreelistss) &&
                            degreelistss.map((degree) => ({
                              value: degree.id,
                              label: degree.title,
                            }))
                          }
                          placeholder="Select an option"
                          value={
                            formik.values.degree_id
                              ? {
                                value: formik.values.degree_id,
                                label: degreelistss?.find(
                                  (item) =>
                                    item.id === formik.values.degree_id
                                ).title,
                              }
                              : null
                          }
                          onChange={handleSpecialityChange}
                        />
                        {formik.touched.degree_id &&
                          formik.errors.degree_id && (
                            <div style={{ color: "red" }}>
                              {formik.errors.degree_id}
                            </div>
                          )}
                      </div>
                      <div className="form-group col-md-12">
                        <label className="label">Field of Study <AsteriskLabel /></label>
                        <input
                          type="text"
                          name="field"
                          className="form-control"
                          placeholder="Type here"
                          value={formik.values.field}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.field && formik.errors.field && (
                          <div style={{ color: "red" }}>
                            {formik.errors.field}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <h6 className="add-edu">Dates Attended </h6>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label className="label">From <AsteriskLabel /></label>
                        <ReactSelect
                          options={generateDateOptions()}
                          placeholder={"Select Year"}
                          isClearable={false}
                          value={
                            formik.values.from_year
                              ? {
                                value: formik.values.from_year,
                                label: formik.values.from_year,
                              }
                              : null
                          }
                          onChange={handleStartDateChange}
                        />
                        {formik.touched.from_year &&
                          formik.errors.from_year && (
                            <div style={{ color: "red" }}>
                              {formik.errors.from_year}
                            </div>
                          )}
                      </div>
                      <div className="form-group col-md-6">
                        <label className="label">To <AsteriskLabel /></label>
                        <ReactSelect
                          options={generateDateOptions()}
                          placeholder={"Select Year"}
                          isClearable={false}
                          value={
                            formik.values.to_year
                              ? {
                                value: formik.values.to_year,
                                label: formik.values.to_year,
                              }
                              : null
                          }
                          onChange={handleEndDateChange}
                        />
                        {formik.touched.to_year && formik.errors.to_year && (
                          <div style={{ color: "red" }}>
                            {formik.errors.to_year}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="add-btn">
                  <button type="submit" className="buttons background-button">
                    {updateIndex != null ? "Update" : "Add"} Education
                  </button>
                  {updateIndex != null && (
                    <p style={{ color: "green" }}>First Update then save</p>
                  )}
                </div>
              </form>
            </div>
          )}
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button className="btn w-25" onClick={SubmitandNext}>
          Save
        </button>
      </div>
    </>
  );
}
